import { helper } from '@ember/component/helper';

export default helper(function add([...args]) {
  let sum = 0;
  args.forEach((item) => {
    sum += +item;
  });
  return sum;
});
